






import { Component, Watch, Vue } from 'vue-property-decorator';
import Route from 'vue-router';
import PrintReport from '@/components/PrintReport.vue'; // @ is an alias to /src

@Component({
  components: {
    PrintReport,
  },
})
export default class Print extends Vue {
  pageId:string = ""

  mounted() {
    this.pageId = this.$route.params.id
  }

  @Watch('$route')
  onRouteUpdate(val:Route, newVal:Route) {
    this.pageId = this.$route.params.id
  }
}
